'use strict';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import fuse from '../../_libs/redux-fusion/index';
import {ManageAccessView} from './ManageAccessView';
import {showManageAccess} from '../manage-access/redux';


// TODO(redux): retrieve from redux state once these are converted from legacy systems: unseenPriority, unseenChat, permissions
export const ManageAccessStreamedComponent = (state$, dispatch) => (props$) => {
  const {
    handler: onShowManageAccess,
    stream: click$,
  } = createEventHandler();

  click$
    .takeUntil(props$.last())
    .withLatestFrom(props$)
    .subscribe(
      ([_, props]) => {
        if (props.target) {
          dispatch(showManageAccess({target: props.target}));
        }
      },
    );

  return props$
    .combineLatest(
      (props) => ({
        ...props,
        onShowManageAccess,
      }));
};

export const ManageAccessContainer = fuse(ManageAccessStreamedComponent)(ManageAccessView);



// WEBPACK FOOTER //
// ./src/js/core-components/ManageAccess/ManageAccessContainer.js